<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading full-character-formatting" epub:type="chapter" id="vol-1-chapter-8" role="doc-chapter">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">8</h1>
</div>
</div>
</div>
</div>
<div class="text" id="vol-1-chapter-8-text">
<p class="first first-in-chapter first-full-width first-with-first-letter-s"><span class="drop-cap">S</span>uddenly the door opened, and all three looked over.</p>
<p class="subsq">A man entered, carrying a briefcase. He was dressed in jeans, polo-necked pullover, green waxed Barbour jacket, leather ankle boots; sharp, calculating eyes set in a tanned oval face; sandy buff hair. He was about forty, lean, and looked fit. He nodded at Black, who nodded back. He walked up to the table and appraised the two detectives.</p>
<p class="subsq">“Gentlemen, my name is Simon Fletcher. I am Mr Black’s appointed solicitor.”</p>
<p class="subsq">He didn’t sit. Instead, he put his briefcase on the table.</p>
<p class="subsq">“I’m hoping this briefcase doesn’t need to be opened. Is my client under arrest?”</p>
<p class="subsq">“Mr Black was very kindly helping us with our enquiries,” answered DI Patterson. “No one’s under arrest.”</p>
<p class="subsq">“I see. If he’s only helping you with your enquiries, I’ll take it that you will not be charging my client?”</p>
<p class="subsq">“We need to keep an open mind. This is a serious incident, you understand. I might remind you, we can keep Mr Black for up to twenty-four hours.”</p>
<p class="subsq">Fletcher cleared his throat, as if he were about to begin a presentation.</p>
<p class="subsq">“What I do understand is that Mr Black was attacked by three men, while out jogging. Yes?”</p>
<p class="subsq">“That would appear to be the case, on the face of it.”</p>
<p class="subsq">“On the face of it. Which usually means that that’s exactly what happened. Therefore, gentlemen, I’ll repeat my question – you’re not intending to charge my client?”</p>
<p class="subsq">DI Patterson shook his head.</p>
<p class="subsq">“If you’re not intending to charge my client, there’s seems to be no reasonable argument for detaining him any longer. Do we agree on this point?”</p>
<p class="subsq">DI Patterson did not respond. DS Lomond’s face remained impassive.</p>
<p class="subsq">“But you’ve taken Mr Black’s clothes, as if he’s been treated like a suspect. Which I assume he’s not. Did you take his shoes?”</p>
<p class="subsq">“It’s routine. You know that. We need to gather the evidence, sometimes as a formality. And yes, we took his shoes.”</p>
<p class="subsq">“Then it looks like I will need to open my briefcase,” said Fletcher.</p>
<p class="subsq">He clicked open two silver-coloured combination locks, opened it up, and produced a pair of training shoes, which he tossed to Black.</p>
<p class="subsq">“Let’s go, Adam. You don’t need to be here anymore.”</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001chapter008.vue?5583cbe6